import emailjs from 'emailjs-com'

const SERVICE_ID = 'service_j5dqqkp' 
const TEMPLATE_ID = 'template_9snsgo2' 
const USER_ID = 'user_KcBsKrBq8dE3jxulSns2q' 

export const sendEmail = (values) => {
    return emailjs.send(SERVICE_ID, TEMPLATE_ID, values, USER_ID)
}